import {
  Component,
  OnInit,
  OnDestroy,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';

// interfaces
import {
  FilterType,
  AppliedFilterType,
} from '@app/core/interfaces/filter.interface';

// services
import { EventBusService } from '@app/core/services/event-bus/event-bus.service';

// rxjs
import { Observable, Subject } from 'rxjs';
import { takeUntil, tap } from 'rxjs/operators';
import { Ag1PillComponent } from './ag1-pill/ag1-pill.component';

@Component({
  selector: 'ag1-pill-group',
  templateUrl: './ag1-pill-group.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [Ag1PillComponent],
})
export class Ag1PillGroupComponent implements OnInit, OnDestroy {
  private eventBus = inject(EventBusService);

  private destroy$ = new Subject<void>();

  filters: FilterType[] = [];
  appliedFilters: AppliedFilterType;

  constructor() {}

  ngOnInit(): void {
    this.filters$().subscribe();
    this.appliedFilters$().subscribe();
  }

  appliedFilters$(): Observable<AppliedFilterType> {
    return this.eventBus.getChannel('appliedFilters').pipe(
      takeUntil(this.destroy$),
      tap((appliedFilters: AppliedFilterType) => {
        this.appliedFilters = appliedFilters;
      }),
    );
  }

  filters$(): Observable<FilterType[]> {
    return this.eventBus.getChannel('filters').pipe(
      takeUntil(this.destroy$),
      tap((filters: FilterType[]) => {
        this.filters = filters;
      }),
    );
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
